import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const OpenNewBrowserIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 14 14" },
        React.createElement("path", { d: "M13.5 0H0.5C0.22388 0 0 0.22388 0 0.5V13.5C0 13.7761 0.22388 14 0.5 14H13.5C13.7761 14 14 13.7761 14 13.5V0.5C14 0.22388 13.7761 0 13.5 0ZM12 6.55151C12 6.83203 11.661 6.97241 11.4627 6.77417L9.85938 5.17078L7.14411 7.8927C7.00153 8.03564 6.76996 8.03577 6.6272 7.89307L6.107 7.37281C5.96424 7.22999 5.96436 6.99854 6.10731 6.85596L8.82917 4.14063L7.22584 2.53724C7.0276 2.339 7.16804 2.00001 7.44837 2.00001H11.6859C11.8594 2.00001 12 2.14063 12 2.31422L12 6.55151Z" })));
};

export { OpenNewBrowserIcon };
//# sourceMappingURL=OpenNewBrowserIcon.esm.js.map
